package com.milta.feature.delivery.data.dto

import com.milta.feature.delivery.domain.entity.AddressValidation
import com.milta.feature.route.domain.entity.toGeocodeFailureReason
import com.milta.feature.route.domain.entity.toGeocodeStatus
import kotlinx.serialization.Serializable

/** Request body of POST api/v1/addresses/validate — one draft address, nothing persisted. */
@Serializable
data class ValidateAddressRequest(val address: String)

/** Mirrors the backend `AddressValidationDto` — HERE validation outcome of one draft address. */
@Serializable
data class AddressValidationResponse(
    val geocodeStatus: String,
    val latitude: Double? = null,
    val longitude: Double? = null,
    val geocodeFailureReason: String? = null,
    val resolvedAddress: String? = null,
)

fun AddressValidationResponse.toDomain() = AddressValidation(
    geocodeStatus = geocodeStatus.toGeocodeStatus(),
    latitude = latitude,
    longitude = longitude,
    geocodeFailureReason = geocodeFailureReason.toGeocodeFailureReason(),
    resolvedAddress = resolvedAddress,
)
